import graphql__e06966cb8650ff870387 from "./__generated__/ContributionsMapThemeContributionsMarkers_map.graphql.js";import { renderToString } from "react-dom/server";
import { graphql, useFragment } from "react-relay";

import MarkerClusterGroup from "../../../Maps/MarkerClusterGroup";
import ContributionsMapContributionMarker from "./ContributionsMapContributionMarker";
import MapElementIcon from "../../../Maps/MapElementIcon";

const ContributionsMapThemeContributionsMarkers = props => {
  const { contributionMarkers, themeId } = props;
  // The `map` fragment provided data is passed down from the parent components to the
  // actual marker component to avoid shared data from the map (themes and other general
  // data) to be fetched again from the markers query.
  const map = useFragment(ContributionsMapThemeContributionsMarkers_map, props.map);
  const { markersMaxClusterRadius } = map;
  const { themes } = map.participativeModule;

  // Fetch the theme from the participative module's theme list, which permits us not to
  // query too much data related to the themes from our contributions markers query, as
  // the themes data is also fetched by other map components, this doesn't add more data
  // loading as we require them from this component.
  const { style } = themes.find(({ id }) => id === themeId);

  const createClusterIcon = cluster => {
    return MapElementIcon({
      iconStyle: {
        ...style,
        content: renderToString(
          <span className="marker-cluster-children-count">{cluster.getChildCount()}</span>
        )
      }
    });
  };

  return (
    <MarkerClusterGroup
      showCoverageOnHover={false}
      maxClusterRadius={markersMaxClusterRadius}
      iconCreateFunction={createClusterIcon}
    >
      {contributionMarkers.map(contributionMarker => (
        <ContributionsMapContributionMarker
          key={contributionMarker.id}
          contributionMarker={contributionMarker}
          map={map}
        />
      ))}
    </MarkerClusterGroup>
  );
};

const ContributionsMapThemeContributionsMarkers_map = graphql__e06966cb8650ff870387;

export default ContributionsMapThemeContributionsMarkers;
